import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=05e82df8&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e82df8')) {
      api.createRecord('05e82df8', component.options)
    } else {
      api.reload('05e82df8', component.options)
    }
    module.hot.accept("./SiteFooter.vue?vue&type=template&id=05e82df8&", function () {
      api.rerender('05e82df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/layout/SiteFooter.vue"
export default component.exports